"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformClientRequest = exports.transformClientListResponse = exports.transformClientResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const luxon_1 = require("luxon");
const Date_1 = require("./Date");
const Error_1 = require("./Error");
function transformClientResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { client } = response.response.result;
    return transformClientParsedResponse(client);
}
exports.transformClientResponse = transformClientResponse;
function transformClientListResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { clients, per_page, total, page, pages } = response.response.result;
    return {
        clients: clients.map((client) => transformClientParsedResponse(client)),
        pages: {
            total,
            size: per_page,
            pages,
            page,
        },
    };
}
exports.transformClientListResponse = transformClientListResponse;
function transformClientParsedResponse(client) {
    return {
        id: client.id,
        allowLateNotifications: client.allow_late_notifications,
        sCode: client.s_code,
        fax: client.fax,
        lastActivity: client.last_activity,
        numLogins: client.num_logins,
        vatNumber: client.vat_number,
        prefEmail: client.pref_email,
        directLinkToken: client.direct_link_token,
        sProvince: client.s_province,
        vatName: client.vat_name,
        fName: client.fname,
        lName: client.lname,
        sCity: client.s_city,
        sStreet2: client.s_street2,
        statementToken: client.statement_token,
        note: client.note,
        mobPhone: client.mob_phone,
        lastLogin: client.last_login && (0, Date_1.transformDateResponse)(client.last_login, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss']),
        homePhone: client.home_phone,
        companyIndustry: client.company_industry,
        subdomain: client.subdomain,
        email: client.email,
        username: client.username,
        updated: client.updated && (0, Date_1.transformDateResponse)(client.updated, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss']),
        pProvince: client.p_province,
        pCity: client.p_city,
        busPhone: client.bus_phone,
        allowLateFees: client.allow_late_fees,
        pStreet: client.p_street,
        companySize: client.company_size,
        accountingSystemId: client.accounting_systemid,
        pCode: client.p_code,
        signupDate: client.signup_date && luxon_1.DateTime.fromSQL(client.signup_date, { zone: 'UTC' }).toJSDate(),
        language: client.language,
        level: client.level,
        notified: client.notified,
        userId: client.userid,
        pStreet2: client.p_street2,
        prefGmail: client.pref_gmail,
        visState: client.vis_state,
        sCountry: client.s_country,
        sStreet: client.s_street,
        organization: client.organization,
        pCountry: client.p_country,
        currencyCode: client.currency_code,
        hasRetainer: client.has_retainer,
        retainerId: client.retainer_id,
        role: client.role,
    };
}
function transformClientRequest(client) {
    return JSON.stringify({
        client: {
            id: client.id,
            allow_late_notifications: client.allowLateNotifications,
            s_code: client.sCode,
            fax: client.fax,
            last_activity: client.lastActivity,
            num_logins: client.numLogins,
            vat_number: client.vatNumber,
            pref_email: client.prefEmail,
            direct_link_token: client.directLinkToken,
            s_province: client.sProvince,
            vat_name: client.vatName,
            fname: client.fName,
            lname: client.lName,
            s_city: client.sCity,
            s_street2: client.sStreet2,
            statement_token: client.statementToken,
            note: client.note,
            mob_phone: client.mobPhone,
            last_login: client.lastLogin,
            home_phone: client.homePhone,
            company_industry: client.companyIndustry,
            subdomain: client.subdomain,
            email: client.email,
            username: client.username,
            p_province: client.pProvince,
            p_city: client.pCity,
            bus_phone: client.busPhone,
            allow_late_fees: client.allowLateFees,
            p_street: client.pStreet,
            company_size: client.companySize,
            accounting_systemid: client.accountingSystemId,
            p_code: client.pCode,
            language: client.language,
            level: client.level,
            notified: client.notified,
            user_id: client.userId,
            p_street2: client.pStreet2,
            pref_gmail: client.prefGmail,
            vis_state: client.visState,
            s_country: client.sCountry,
            s_street: client.sStreet,
            organization: client.organization,
            p_country: client.pCountry,
            currency_code: client.currencyCode,
            has_retainer: client.hasRetainer,
            retainer_id: client.retainerId,
            role: client.role,
        },
    });
}
exports.transformClientRequest = transformClientRequest;
//# sourceMappingURL=Client.js.map